import React from 'react'
import { useHistory } from 'react-router-dom'
import { HiSearch } from 'react-icons/hi'
import { IoCartOutline } from 'react-icons/io5'

import Logo from '../Logo'
import SmallButton from '../SmallButton'
import * as S from './styles'
import { useWindowSizeHook } from 'hooks/useWindowHooks'

const Header = () => {
  const { width } = useWindowSizeHook()
  const history = useHistory()

  return (
    <S.Wrapper>
      <S.WrapperLeft>
        <Logo size="small" />
        {width >= 572 && (
          <S.Nav>
            <ul>
              <li>Home</li>
              <li>Store</li>
            </ul>
          </S.Nav>
        )}
      </S.WrapperLeft>
      <S.WrapperRight>
        {width >= 572 && (
          <>
            <HiSearch size="24" />
            <IoCartOutline size="24" />
          </>
        )}

        <SmallButton onClick={() => history.push('/signin')}>
          Sign in
        </SmallButton>
      </S.WrapperRight>
    </S.Wrapper>
  )
}

export default Header
